<ng-select
  [formControl]="booleanFc"
  [searchable]="false"
  [clearable]="clearable">
  <ng-option [value]="true"><love-it-display-boolean [value]="true"></love-it-display-boolean></ng-option>
  <ng-option [value]="false"><love-it-display-boolean [value]="false"></love-it-display-boolean></ng-option>
</ng-select>
